import Wrapper from '@kaidam/fc-shared/src/frontend/components/form/Wrapper'
export default Wrapper